/**
 * InfiniteNote 公共数据库访问工具
 * 用于访问 InfiniteNote 的 data 表，存储用户相关公共数据
 * 
 * 注意：此文件现在使用 dbManager.ts 中的函数
 */

import {
  saveToMainDB,
  getFromMainDB,
  deleteFromMainDB
} from './dbManager'

// 保存数据到 InfiniteNote 的 data 表
export async function saveToInfiniteNoteDB(key: string, value: any): Promise<void> {
  await saveToMainDB(key, value)
}

// 从 InfiniteNote 的 data 表读取数据
export async function getFromInfiniteNoteDB(key: string): Promise<any> {
  return await getFromMainDB(key)
}

// 删除 InfiniteNote 的 data 表中的数据
export async function deleteFromInfiniteNoteDB(key: string): Promise<void> {
  await deleteFromMainDB(key)
}

// 专用函数：保存当前用户
export async function saveCurrentUser(userUuid: string): Promise<void> {
  await saveToMainDB('currentUser', userUuid)
}

// 专用函数：获取当前用户
export async function getCurrentUser(): Promise<string | null> {
  return await getFromMainDB('currentUser')
}

// 专用函数：保存用户列表
export async function saveUsers(users: any[]): Promise<void> {
  await saveToMainDB('users', users)
}

// 专用函数：获取用户列表
export async function getUsers(): Promise<any[]> {
  const users = await getFromMainDB('users')
  return users || []
}

// 专用函数：保存应用设置
export async function saveAppSettings(settings: any): Promise<void> {
  await saveToMainDB('appSettings', settings)
}

// 专用函数：获取应用设置
export async function getAppSettings(): Promise<any | null> {
  return await getFromMainDB('appSettings')
}
